webpackJsonp([2],{

/***/ 1177:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentTemplates_vue__ = __webpack_require__(1201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af0a5796_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocumentTemplates_vue__ = __webpack_require__(1205);
var normalizeComponent = __webpack_require__(8)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentTemplates_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af0a5796_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocumentTemplates_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1178:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BackToLastTrajectory_vue__ = __webpack_require__(1179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43185190_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BackToLastTrajectory_vue__ = __webpack_require__(1180);
var normalizeComponent = __webpack_require__(8)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BackToLastTrajectory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43185190_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BackToLastTrajectory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1179:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BackToLastTrajectory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_property_decorator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_property_decorator__);





var _class;




var BackToLastTrajectory = Object(__WEBPACK_IMPORTED_MODULE_5_vue_property_decorator__["Component"])(_class = function (_Vue) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(BackToLastTrajectory, _Vue);

  function BackToLastTrajectory() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, BackToLastTrajectory);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (BackToLastTrajectory.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(BackToLastTrajectory)).apply(this, arguments));
  }

  return BackToLastTrajectory;
}(__WEBPACK_IMPORTED_MODULE_4_vue__["default"])) || _class;



/***/ }),

/***/ 1180:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[(_vm.$store.state.trajectory.trajectory.id)?_c('div',{staticClass:"breadcrumb"},[_c('router-link',{attrs:{"to":{ name: 'dashboard', param: {id: _vm.$store.state.trajectory.trajectory.id} }}},[_c('i',{staticClass:"icons icon-arrow-left"}),_vm._v(" "+_vm._s(_vm.$t('common.back_last_trajectory'))+"\n            ")])],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1201:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SurveyTemplates; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_tables_document_templates_DocumentTemplatesTable__ = __webpack_require__(1202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_general_BackToLastTrajectory__ = __webpack_require__(1178);






var _dec, _class;






var SurveyTemplates = (_dec = __WEBPACK_IMPORTED_MODULE_6_vue_class_component___default()({
    components: {
        DocumentTemplatesTable: __WEBPACK_IMPORTED_MODULE_7__components_tables_document_templates_DocumentTemplatesTable__["a" /* default */],
        BackToLastTrajectory: __WEBPACK_IMPORTED_MODULE_8__components_general_BackToLastTrajectory__["a" /* default */]
    }
}), _dec(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(SurveyTemplates, _Vue);

    function SurveyTemplates() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SurveyTemplates);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = SurveyTemplates.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(SurveyTemplates)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'survey-templates', _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(SurveyTemplates, [{
        key: 'addNew',
        value: function addNew() {
            this.$router.push({
                name: 'document-template',
                params: {
                    id: 'new'
                }
            });
        }
    }]);

    return SurveyTemplates;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"])) || _class);


/***/ }),

/***/ 1202:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentTemplatesTable_vue__ = __webpack_require__(1203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6690b720_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocumentTemplatesTable_vue__ = __webpack_require__(1204);
var normalizeComponent = __webpack_require__(8)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentTemplatesTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6690b720_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocumentTemplatesTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1203:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DocumentTemplatesTable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_tables_Pagination__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_modules_document_templates__ = __webpack_require__(213);






var _dec, _class;






var DocumentTemplatesTable = (_dec = __WEBPACK_IMPORTED_MODULE_6_vue_class_component___default()({
    components: {
        Pagination: __WEBPACK_IMPORTED_MODULE_7__components_tables_Pagination__["a" /* default */]
    }
}), _dec(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(DocumentTemplatesTable, _Vue);

    function DocumentTemplatesTable() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, DocumentTemplatesTable);

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (DocumentTemplatesTable.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(DocumentTemplatesTable)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(DocumentTemplatesTable, [{
        key: 'mounted',
        value: function mounted() {
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_8__store_modules_document_templates__["a" /* GET_DOCUMENT_TEMPLATES */], {});
        }
    }, {
        key: 'goToPage',
        value: function goToPage(pageNo) {
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_8__store_modules_document_templates__["a" /* GET_DOCUMENT_TEMPLATES */], { params: { page: pageNo } });
        }
    }, {
        key: 'editTemplate',
        value: function editTemplate(template) {
            this.$router.push({ name: 'document-template', params: { id: template.id } });
        }
    }, {
        key: 'showDeleteTemplateModal',
        value: function showDeleteTemplateModal(template) {
            var content = {
                title: this.$t('modals.delete_template.title'),
                message: this.$t('modals.delete_template.message')
            };
            this.$modal.show('confirmation-modal', { content: content, callback: this.deleteTemplate, template: template });
        }
    }, {
        key: 'deleteTemplate',
        value: function deleteTemplate(_ref) {
            var _this2 = this;

            var template = _ref.template;

            template.remove().then(function () {
                _this2.$notify.success(_this2.$t('notify.template.delete_success'));
                _this2.$store.dispatch(__WEBPACK_IMPORTED_MODULE_8__store_modules_document_templates__["a" /* GET_DOCUMENT_TEMPLATES */], {});
            }).catch(function (err) {
                return _this2.$notify.error(_this2.$t('notify.template.delete_error'));
            });
        }
    }, {
        key: 'documentTemplates',
        get: function get() {
            return this.$store.state.document_templates.templates;
        }
    }, {
        key: 'loadingDocumentTemplates',
        get: function get() {
            return this.$store.state.document_templates.loading;
        }
    }, {
        key: 'documentTemplatesMeta',
        get: function get() {
            return this.$store.state.document_templates.templatesMeta;
        }
    }]);

    return DocumentTemplatesTable;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"])) || _class);


/***/ }),

/***/ 1204:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table__responsive"},[_c('table',{staticClass:"table"},[(!_vm.loadingDocumentTemplates && _vm.documentTemplates.length)?_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('document_templates.table.header.id')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('document_templates.table.header.name')))]),_vm._v(" "),_c('th',{staticClass:"table__cell--icon"}),_vm._v(" "),_c('th',{staticClass:"table__cell--icon"})])]):_vm._e(),_vm._v(" "),_c('tbody',[(_vm.loadingDocumentTemplates)?_c('tr',{staticClass:"table--loading"},[_c('td',{attrs:{"colspan":"5"}},[_c('div',{staticClass:"spinner"}),_vm._v(" "),_c('div',{staticClass:"text-center loading_text"},[_vm._v(_vm._s(_vm.$t('document_templates.table.loading')))])])]):(!_vm.documentTemplates.length)?_c('tr',{staticClass:"table--empty"},[_c('td',{attrs:{"colspan":"5"}},[_c('div',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$t('document_templates.table.no_document_templates')))])])]):_vm._l((_vm.documentTemplates),function(template){return _c('tr',{key:template.id},[_c('td',[_vm._v(_vm._s(template.id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(template.name))]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.right",value:('Edit'),expression:"'Edit'",modifiers:{"right":true}}],staticClass:"table__icon icons icon-pencil",on:{"click":function($event){_vm.editTemplate(template)}}})]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.bottom",value:(_vm.$t('document_templates.table.delete')),expression:"$t('document_templates.table.delete')",modifiers:{"bottom":true}}],staticClass:"table__icon icons icon-trash",on:{"click":function($event){_vm.showDeleteTemplateModal(template)}}})])])}),_vm._v(" "),(_vm.documentTemplatesMeta && _vm.documentTemplatesMeta.last_page > 1)?_c('tr',{staticClass:"table__navigation"},[_c('td',{attrs:{"colspan":"5"}},[_c('pagination',{attrs:{"meta":_vm.documentTemplatesMeta},on:{"goToPage":_vm.goToPage}})],1)]):_vm._e()],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1205:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('back-to-last-trajectory'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"panel"},[_c('div',{staticClass:"panel__header"},[_c('h2',[_c('i',{staticClass:"panel__header__icon icons icon-docs"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('document_templates.title')))])]),_vm._v(" "),_c('div',{staticClass:"panel_header__action",on:{"click":function($event){$event.preventDefault();return _vm.addNew($event)}}},[_c('i',{staticClass:"panel_header__action__icon icons icon-plus"}),_vm._v(" "),_c('a',{staticClass:"button--link"},[_vm._v(_vm._s(_vm.$t('document_templates.add_new')))])])]),_vm._v(" "),_c('div',{staticClass:"panel__body"},[_c('document-templates-table')],1)])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/2.7b25b3318dd618b4fa4b.js